import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ImageConfig } from '../config/ImageConfig'
import uploadImg from '../assets/cloud-upload-regular-240.png';
import ClearIcon from '@mui/icons-material/Clear';
import './drop-file-input.css';

const DropFileInput = props => {

    function bytesToSize(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
        if (bytes === 0) return 'n/a'
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
        if (i === 0) return `${bytes} ${sizes[i]}`
        return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    }

    const wrapperRef = useRef(null);

    const [fileList, setFileList] = useState([]);

    const onDragEnter = () => wrapperRef.current.classList.add('dragover');

    const onDragLeave = () => wrapperRef.current.classList.remove('dragover');

    const onDrop = () => wrapperRef.current.classList.remove('dragover');

    const onFileDrop = (e) => {
        const newFiles = e.target.files;
        if (newFiles && newFiles.length) {
            let newArray = [...fileList]
            for (let i = 0; i < newFiles.length; i++) {
                newArray.push(newFiles[i])
            }
            const updatedList = newArray;
            setFileList(updatedList);
            props.onFileChange(updatedList);
        }
    }
    const fileRemove = (file) => {
        const updatedList = [...fileList];
        updatedList.splice(fileList.indexOf(file), 1);
        setFileList(updatedList);
        props.onFileChange(updatedList);
    }

    React.useEffect(() => {
        if (props.files.length > 0) {
            const filesArray = [];
            props.files.forEach(element => {
                filesArray.push(element)
            });
            const updatedList = filesArray
            setFileList(updatedList);
        }
    }, []);

    return (
        <>
            <div
                ref={wrapperRef}
                className="drop-file-input"
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                <div className="drop-file-input__label">
                    <img src={uploadImg} alt="" />
                    <p>Busca un archivo para adjuntar o arrastra y suelta los archivos aquí.</p>
                </div>
                <input type="file" value="" onChange={onFileDrop} multiple />
            </div>
            {
                fileList.length > 0 ? (
                    <div className="drop-file-preview">
                        {
                            fileList.map((item, index) => (
                                <div key={index} className="drop-file-preview__item">
                                    <img src={ImageConfig[item.type.split('/')[1]] || ImageConfig['default']} alt="" />
                                    <div className="drop-file-preview__item__info">
                                        <p style={{ margin: '0px' }}>{item.name}</p>
                                        <p style={{ margin: '0px' }}>{bytesToSize(item.size)}</p>
                                    </div>
                                    <span className="drop-file-preview__item__del" onClick={() => fileRemove(item)}><ClearIcon style={{ fontSize: '15px' }} /></span>
                                </div>
                            ))
                        }
                    </div>
                ) : null
            }
        </>
    );
}

DropFileInput.propTypes = {
    onFileChange: PropTypes.func
}

export default DropFileInput;